import { useEffect } from "react";
import { track } from "../lib/track";
import { Rise, Words } from "../components/Reveal";
import { COPY } from "../content/copy";

export default function Patto() {
    useEffect(() => {
        const el = document.getElementById("patto");
        if (!el || !("IntersectionObserver" in window)) return;
        const io = new IntersectionObserver((es) => {
            if (es.some((e) => e.isIntersecting)) {
                track("scroll_patto");
                io.disconnect();
            }
        }, { threshold: 0.3 });
        io.observe(el);
        return () => io.disconnect();
    }, []);
    const p = COPY.patto;
    return (
        <section id="patto" className="section patto" data-testid="patto-block">
            <div className="container">
                <Rise>
                    <p className="caption">{p.caption}</p>
                </Rise>
                <Rise delay={0.05}>
                    <h2 className="h2 section-title" data-testid="patto-title">
                        <Words text={p.titleA} />{" "}
                        <Words text={p.titleB} italic />
                    </h2>
                </Rise>
                <div className="patto-rows">
                    {p.cells.map((c, i) => (
                        <Rise key={c.neg} delay={i * 0.08} className="patto-row">
                            <div className="patto-neg">
                                <h3 data-testid={`patto-neg-${i}`}>{c.neg}</h3>
                                <p>{c.negText}</p>
                            </div>
                            <span className="patto-arrow" aria-hidden="true">→</span>
                            <div className="patto-pos">
                                <h3 data-testid={`patto-pos-${i}`}>{c.pos}</h3>
                                <p>{c.posText}</p>
                            </div>
                        </Rise>
                    ))}
                </div>
            </div>
        </section>
    );
}
